import React from 'react';
export function BirthdayIcon(props) {
  var className = props && props.className ? 'wink-icon ' + props.className : 'wink-icon';
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    focusable: "false",
    "aria-hidden": "true"
  }, props, {
    className: className
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 8h-2V6a1 1 0 00-2 0v2h-2V6a1 1 0 00-2 0v2H9V6a1 1 0 00-2 0v2H5a3 3 0 00-3 3v8a3 3 0 003 3h14a3 3 0 003-3v-8a3 3 0 00-3-3zM5 10h14a1 1 0 011 1v1.651a3.874 3.874 0 00-1.056.516 1.516 1.516 0 01-1.9 0 3.5 3.5 0 00-4.111 0 1.51 1.51 0 01-1.89 0 3.342 3.342 0 00-2.05-.667 3.347 3.347 0 00-2.054.668A1.4 1.4 0 016 13.5c-.344.01-.68-.109-.942-.332A3.875 3.875 0 004 12.651V11a1 1 0 011-1zm14 10H5a1 1 0 01-1-1v-4.132c.58.424 1.282.646 2 .632.74.01 1.462-.225 2.054-.668a1.509 1.509 0 011.889 0 3.492 3.492 0 004.108 0 1.515 1.515 0 011.893 0A3.355 3.355 0 0018 15.5a3.3 3.3 0 002-.635V19a1 1 0 01-1 1zM8 4a1 1 0 100-2 1 1 0 000 2zM12 4a1 1 0 100-2 1 1 0 000 2zM16 4a1 1 0 100-2 1 1 0 000 2z"
  }));
}